
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 51 51"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M33.915 25.5L49.693 9.724a4.46 4.46 0 000-6.31l-2.1-2.1a4.46 4.46 0 00-6.311 0L25.5 17.088 9.724 1.307a4.46 4.46 0 00-6.31 0l-2.107 2.1a4.461 4.461 0 000 6.311L17.088 25.5 1.311 41.279a4.46 4.46 0 000 6.311l2.1 2.1a4.46 4.46 0 006.31 0L25.5 33.915l15.779 15.778a4.461 4.461 0 006.311 0l2.1-2.1a4.461 4.461 0 000-6.311zm0 0"}})])
          )
        }
      }
    